module.exports = __webpack_public_path__ + "media/front/ico-rate-checkbox-check-8de55f0e.svg";